import React from 'react'
import { TAG_BLOCK_AUTOPROMO } from '../analytics/analytics.tagids.constants'
import { MODAL_IDS } from '../../store/ui/ui.constants'
import analyticsConstants from '../analytics/analytics.constants'
import qrcode from '../genericComponents/assets/qrcode.svg'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM,
} from '../genericComponents/buttons/RectangleActionButton'
import { withFrenchSite } from '../i18n/i18nSite'
import useModal from '../ui/useModal'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'
import AutoPromoPopinGE from './AutoPromoPopinGE'

const AutoPromoOpenButton = ({ size = SIZE_MEDIUM, area }) => {
  const { displayModal } = useModal(MODAL_IDS.AUTO_PROMO_POPIN)

  const onButtonClick = useErrorBoundaryCallback(displayModal)

  return (
    <>
      <RectangleActionButton
        iconUrl={qrcode}
        color={COLOR_GREY_EMPTY}
        label="Installer l'App"
        size={size}
        onClick={onButtonClick}
        tagData={{
          type: TAG_BLOCK_AUTOPROMO,
          tagInfo: {
            appstore: analyticsConstants.autopromo.stores.qrcode,
            area
          }
        }}
      />
      <AutoPromoPopinGE />
    </>
  )
}

export default withFrenchSite(AutoPromoOpenButton)
